import { useCallback, useState } from 'react'
import type {
  TFinancingRequestStepperAfterFormSubmitHandler,
  TFinancingRequestStepperCallbacks,
  TFinancingRequestStepperErrorFormSubmitHandler,
  TFinancingRequestStepperState,
  TFinancingRequestStepperSuccessFormSubmitHandler,
} from '../types'
import { EFinancingConsultingStep } from '../types'

export const useFinancingRequestStepper = <TForm extends Record<string, unknown>>() => {
  const [state, setState] = useState<TFinancingRequestStepperState<TForm>>({ step: EFinancingConsultingStep.FORM })

  const onStartLogin = useCallback(() => {
    setState(previousState => ({ ...previousState, step: EFinancingConsultingStep.LOGIN }))
  }, [])

  const onFinishLogin = useCallback(() => {
    setState(previousState => ({ ...previousState, step: EFinancingConsultingStep.FORM }))
  }, [])

  const onStartRegistration = useCallback(() => {
    setState(previousState => ({ ...previousState, step: EFinancingConsultingStep.REGISTRATION }))
  }, [])

  const onFinishRegistration = useCallback((formValues: TForm) => {
    setState(previousState => ({ ...previousState, step: EFinancingConsultingStep.FORM, initialFormValues: formValues }))
  }, [])

  const onError: TFinancingRequestStepperErrorFormSubmitHandler = useCallback(() => {
    setState(previousState => ({ ...previousState, step: EFinancingConsultingStep.ERROR }))
  }, [])

  const onSuccess: TFinancingRequestStepperSuccessFormSubmitHandler = useCallback(fundingRequestId => {
    setState(previousState => ({ ...previousState, step: EFinancingConsultingStep.SUCCESS, fundingRequestId }))
  }, [])

  const onResetForm = useCallback(() => {
    setState({ step: EFinancingConsultingStep.FORM })
  }, [])

  const onAfterFormSubmit: TFinancingRequestStepperAfterFormSubmitHandler = useCallback(fundingRequestId => {
    setState(previousState => ({ ...previousState, step: EFinancingConsultingStep.AFTER_FORM_SUBMIT, fundingRequestId }))
  }, [])

  const handlers: TFinancingRequestStepperCallbacks<TForm> = {
    onStartLogin,
    onFinishLogin,
    onStartRegistration,
    onFinishRegistration,
    onError,
    onSuccess,
    onResetForm,
    onAfterFormSubmit,
  }

  return {
    state,
    handlers,
  }
}
